import * as React from 'react';
import { CircleHelp } from 'lucide-react';

import { Button } from '../../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface InfoPopoverProps {
  align?: 'center' | 'end' | 'start';
  ariaLabel?: string;
  description: string;
  side?: 'bottom' | 'left' | 'right' | 'top';
  title: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function InfoPopover({
  align = 'end',
  ariaLabel,
  description,
  side = 'bottom',
  title,
}: InfoPopoverProps): React.JSX.Element {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          aria-label={ariaLabel ?? title}
          className="h-9 w-9 rounded-md"
          size="icon"
          type="button"
          variant="ghost"
        >
          <CircleHelp className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align={align} className="w-80 space-y-1.5 text-sm" side={side}>
        <p className="font-medium text-foreground">{title}</p>
        <p className="text-muted-foreground">{description}</p>
      </PopoverContent>
    </Popover>
  );
}
